export const Dollar = value => `$${parseFloat(value).toFixed(2)}`
